import { Platform, View } from 'react-native';
import { clsx } from 'clsx';
import { useTranslation } from 'react-i18next';
import { Text } from 'shared/components/text';

export function TypingIndicator({ name, padded = true }: { name: string; padded?: boolean }) {
  const { t } = useTranslation('components');

  return (
    <View
      testID={'chat-typing-indicator'}
      className={clsx(
        'flex-row items-center gap-2 py-2',
        padded && (Platform.OS === 'web' ? 'px-3 md:px-4' : 'px-4'),
      )}
    >
      <View
        aria-hidden={true}
        className={'flex-row items-center gap-1 rounded-2xl rounded-bl-none bg-stone-100 p-3'}
      >
        <View className={'size-1.5 rounded-full bg-stone-400 motion-safe:animate-pulse'} />
        <View className={'size-1.5 rounded-full bg-stone-400 motion-safe:animate-pulse'} />
        <View className={'size-1.5 rounded-full bg-stone-400 motion-safe:animate-pulse'} />
      </View>
      <Text
        className={'min-w-0 flex-1 text-sm text-stone-500'}
        accessibilityLiveRegion={'polite'}
        numberOfLines={1}
      >
        {t('chat.typing', { name })}
      </Text>
    </View>
  );
}
